import {styled} from '@linaria/react';
import React from 'react';
import {FONT_SIZES} from '../../../constants/typography';
import {Text} from '../../atoms/Text';

export const SliderCounter: React.FC<{
  slidesCount: number;
  currentSlide: number;
  dataTestid?: string;
  className?: string;
}> = ({slidesCount, currentSlide, dataTestid, className}) => {
  return (
    <CounterContainer data-testid={dataTestid} className={className}>
      {`${currentSlide} / ${slidesCount}`}
    </CounterContainer>
  );
};

const CounterContainer = styled(Text)`
  text-align: center;
  display: inline-block;
  border-radius: 1rem;
  padding: 0.25rem 0.5rem;
  background-color: rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(16px);
  font-size: ${FONT_SIZES.px12};
  letter-spacing: 2px;
`;
